import { render, staticRenderFns } from "./average-value.vue?vue&type=template&id=72531362&scoped=true"
import script from "./average-value.vue?vue&type=script&lang=js"
export * from "./average-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72531362",
  null
  
)

export default component.exports